import { ToolbarCylinderIcon } from '@editor/assets/icons'
import { EDITOR_TOOLS, EDITOR_TOOLS_LABELS, ProductTypes } from '@editor/config/constants'
import { CursorState } from '@editor/config/constants/cursor'
import { EditorTool, ToolbarCategory } from '@editor/interfaces/editor'
import { UserInfo } from '@editor/interfaces/user'

import DiameterPanel from './components/DiameterPanel'
import useEditor from './hooks/useEditor'
import useElementsPanel from './hooks/useElementsPanel'
import useMainCanvas from './hooks/useMainCanvas'

const RebarDetection: EditorTool = {
  key: EDITOR_TOOLS.CYLINDER,
  cursor: CursorState.CROSSHAIR,
  authCheck: (userProfile: UserInfo | null, isAllowedToModify: boolean) =>
    (userProfile?.owned_products.includes(ProductTypes.Hatsuly) && isAllowedToModify) || false,
  toolbar: {
    icon: <ToolbarCylinderIcon width="50%" height="50%" />,
    label: EDITOR_TOOLS_LABELS.CYLINDER,
    category: ToolbarCategory.Generate,
  },
  components: {
    panel: DiameterPanel,
  },
  hooks: {
    useEditor,
    useMainCanvas,
    useElementsPanel,
  },
  config: {
    anchor: {
      notPlaceableOnObjects: true,
    },
    dependencies: [EDITOR_TOOLS.VOLUME_POLYGON, EDITOR_TOOLS.DEPTH, EDITOR_TOOLS.GRID],
  },
}

export default RebarDetection
